import React, { useState } from "react";
import {
  Button,
  ButtonContainer,
  ButtonIcon,
  VacancyCard,
} from "./AdminStyles";
import { smartAPI } from "../../components/api/Smart";
import {
  faCheck,
  faClipboard,
  faEnvelope,
  faPhone,
  faTrash,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Messages = ({ contacts, setContacts }) => {
  const [message, setMessage] = useState("");

  // Delete handler
  const handleDelete = async (id) => {
    const isConfirmed = window.confirm(
      "Weet je zeker dat je dit contactformulier wilt verwijderen?"
    );

    if (!isConfirmed) return;

    try {
      const response = await smartAPI({}, "DELETE", `contact/${id}`);
      if (response.status === 204) {
        setMessage("Contactformulier succesvol verwijderd!");
        setTimeout(() => setMessage(""), 3000);
        fetchContact();
      }
    } catch (error) {
      console.error("API request failed:", error);
    }
  };

  async function fetchContact() {
    try {
      const response = await smartAPI({}, "GET", "contact");
      if (response.status === 200) {
        setContacts(response.data);
      } else {
        setMessage("Er is iets misgegaan, probeer het opnieuw.");
      }
    } catch (error) {
      setMessage("Fout bij het verzenden, probeer later opnieuw.");
    }
  }

  return (
    <>
      {message && (
        <p
          style={{
            color: "white",
            fontWeight: "bold",
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
            backgroundColor: "#17224d",
            borderRadius: "5px",
            padding: "10px",
            border: "1px solid black",
          }}
        >
          <FontAwesomeIcon
            icon={faCheck}
            style={{ color: "green", marginRight: "10px" }}
          />
          {message}
        </p>
      )}
      <div
        className="vacancy-row"
        style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
      >
        {contacts.map((contact) => (
          <VacancyCard key={contact.id}>
            <div>
              <FontAwesomeIcon icon={faUser} style={{ marginRight: "8px" }} />
              <strong>Naam:</strong> {contact.name}
            </div>
            <div>
              <FontAwesomeIcon icon={faPhone} style={{ marginRight: "8px" }} />
              <strong>Telefonnummer:</strong> {contact.phone}
            </div>
            <div>
              <FontAwesomeIcon
                icon={faClipboard}
                style={{ marginRight: "8px" }}
              />
              <strong>Onderwerp:</strong> {contact.subject}
            </div>
            <div>
              <FontAwesomeIcon
                icon={faEnvelope}
                style={{ marginRight: "8px" }}
              />
              <strong>Bericht:</strong> {contact.message}
            </div>
            <div>
              <FontAwesomeIcon
                icon={faEnvelope}
                style={{ marginRight: "8px" }}
              />
              <strong>Email:</strong> {contact.mail}
            </div>
            <ButtonContainer>
              <Button
                style={{
                  backgroundColor: "oklch(0.637 0.237 25.331)",
                  width: "100%",
                  marginTop: "20px",
                }}
                onClick={() => handleDelete(contact.id)}
              >
                <ButtonIcon icon={faTrash} /> Verwijderen
              </Button>
            </ButtonContainer>
          </VacancyCard>
        ))}
      </div>
    </>
  );
};

export default Messages;
